import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AuthService} from '../core/services/auth.service';
import { Login } from '../models/login';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public showErrorMessage = false;

  constructor(
    private _fb: FormBuilder,
    private _authService: AuthService,
    private _router: Router,
    ) { }

  ngOnInit(): void {
    this.loginForm = this._fb.group({
      email: [''],
      password: [''],
    });

  }

  loginSubmit({value}: {value: Login}){
    this._authService.fetchToken(value).subscribe(token => {
      if (token.error) {
        this._authService.removeToken();
        this.loginForm.reset();
        this.showErrorMessage = true;
      }else{
        this._authService.saveToken('token', token.access);
        this._authService.saveToken('refresh_token', token.refresh);
        void this._router.navigate(['dashboard']);
        this.loginForm.reset();
      }

    });
  }
}
